import { createGlobalStyle, css } from 'styled-components'
import { headerHeightPx } from '../../header'
import { Color } from './color'
import { mobile } from './media-queries'

export const GlobalStyle = createGlobalStyle`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  body {
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    background-color: ${Color.white};
  }
  * {
    font-family: 'Circular Std', Verdana, Geneva, Tahoma, sans-serif;
  }
`

export const fullHeightCss = css`
  height: calc(calc(var(--vh, 1vh) * 100) - ${headerHeightPx.desktop}px);
  @media ${mobile} {
    height: calc(calc(var(--vh, 1vh) * 100) - ${headerHeightPx.mobile}px);
  }
`
